import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import { getBaseMenuTree, getMenuAuthority, addMenuAuthority } from '@/api/menu';
import { updateAuthority } from "@/api/authority";
export default {
  name: 'Menus',
  props: {
    row: {
      default: function _default() {
        return {};
      },
      type: Object
    }
  },
  data: function data() {
    return {
      menuTreeData: [],
      menuTreeIds: [],
      needConfirm: false,
      menuDefaultProps: {
        children: 'children',
        label: function label(data) {
          return data.meta.title;
        }
      }
    };
  },
  methods: {
    setDefault: function setDefault(data) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return updateAuthority({
                authorityId: _this.row.authorityId,
                AuthorityName: _this.row.authorityName,
                parentId: _this.row.parentId,
                defaultRouter: data.name
              });
            case 2:
              res = _context.sent;
              if (res.code == 0) {
                _this.$message({
                  type: "success",
                  message: "设置成功"
                });
                _this.row.defaultRouter = res.data.authority.defaultRouter;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    nodeChange: function nodeChange() {
      this.needConfirm = true;
    },
    // 暴露给外层使用的切换拦截统一方法
    enterAndNext: function enterAndNext() {
      this.relation();
    },
    // 关联树 确认方法
    relation: function relation() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var checkArr, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              checkArr = _this2.$refs.menuTree.getCheckedNodes(false, true);
              _context2.next = 3;
              return addMenuAuthority({
                menus: checkArr,
                authorityId: _this2.row.authorityId
              });
            case 3:
              res = _context2.sent;
              if (res.code == 0) {
                _this2.$message({
                  type: 'success',
                  message: '菜单设置成功!'
                });
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  },
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var res, res1, menus, arr;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getBaseMenuTree();
          case 2:
            res = _context3.sent;
            _this3.menuTreeData = res.data.menus;
            _context3.next = 6;
            return getMenuAuthority({
              authorityId: _this3.row.authorityId
            });
          case 6:
            res1 = _context3.sent;
            menus = res1.data.menus;
            arr = [];
            menus.map(function (item) {
              // 防止直接选中父级造成全选
              if (!menus.some(function (same) {
                return same.parentId === item.menuId;
              })) {
                arr.push(Number(item.menuId));
              }
            });
            _this3.menuTreeIds = arr;
          case 11:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }
};